import React from 'react';
import CSSModules from 'react-css-modules';
import { FormattedMessage } from 'react-intl';
import * as PropTypes from 'prop-types';
import cn from 'classnames';
import size from 'lodash/size';
import uniq from 'lodash/uniq';

import { formatHours } from '../../../../utils/appointments/dateFilter';
import styles from './styles.styl';

function TimeSlots({ list, variant, onSelect, activeSlot }) {
  return (
    <div styleName={cn('root', variant)}>
      {uniq(list).map(slot => (
        <div
          key={slot}
          styleName={cn('slot', { 'active-slot': slot === activeSlot })}
          onClick={() => onSelect(slot)}
        >
          {formatHours(slot)}
        </div>
      ))}
      {!size(list) && (
        <div styleName="emptyList">
          <FormattedMessage id="appointments.form.noAvailableProviders" />
        </div>
      )}
    </div>
  );
}

TimeSlots.propTypes = {
  list: PropTypes.array,
  onSelect: PropTypes.func,
  variant: PropTypes.oneOf(['sm', 'md']),
  activeSlot: PropTypes.string,
};

TimeSlots.defaultProps = {
  variant: 'md',
};

export default CSSModules(TimeSlots, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/Components/TimeSlots/index.jsx